import { Trophy, Star, Target, Zap, Award, CheckCircle2 } from 'lucide-react';
import type { Achievement } from './types';

export const ACHIEVEMENTS_DATA: Omit<Achievement, 'unlocked'>[] = [
  {
    id: 'first-visit',
    title: 'Welcome Aboard!',
    description: 'Visited the portfolio for the first time',
    icon: Star,
  },
  {
    id: 'explorer',
    title: 'Explorer',
    description: 'Opened 5 different apps',
    icon: Target,
    progress: 0,
    maxProgress: 5,
  },
  {
    id: 'completionist',
    title: 'Completionist',
    description: 'Opened every single app',
    icon: Award,
    progress: 0,
    maxProgress: 11,
  },
  {
    id: 'project-viewer',
    title: 'Project Inspector',
    description: 'Viewed 5 projects in the Projects app',
    icon: Zap,
    progress: 0,
    maxProgress: 5,
  },
  {
    id: 'terminal-master',
    title: 'Terminal Master',
    description: 'Ran 10 terminal commands',
    icon: CheckCircle2,
    progress: 0,
    maxProgress: 10,
  },
  {
    id: 'konami-code',
    title: 'Secret Gamer',
    description: 'Discovered the Konami code easter egg',
    icon: Trophy,
  },
  {
    id: 'game-player',
    title: 'Game Player',
    description: 'Played all mini games',
    icon: Trophy,
    progress: 0,
    maxProgress: 2,
  },
  {
    id: 'night-owl',
    title: 'Night Owl',
    description: 'Switched to dark mode',
    icon: Star,
  },
  {
    id: 'customizer',
    title: 'Customizer',
    description: 'Changed the wallpaper',
    icon: Star,
  },
  {
    id: 'persistence',
    title: 'Regular Visitor',
    description: 'Returned after closing the tab',
    icon: Award,
  },
];
